import { render, staticRenderFns } from "./SetAssigneeModal.vue?vue&type=template&id=af3cba8a&"
import script from "./SetAssigneeModal.vue?vue&type=script&lang=js&"
export * from "./SetAssigneeModal.vue?vue&type=script&lang=js&"
import style0 from "./SetAssigneeModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports